module.exports = __webpack_public_path__ + "static/media/ic_laptop.9b91c66a.svg";